<div class="results-body">
  @if (realtimeCallData()) {
    <app-call-tavus-overlay
      class="results-overlay"
      [realtimeService]="realtimeService"
      [callUuid]="callUuid()"
      [showCameraStream]="true"
      [userDisplayName]="userDisplayName"
      [userIsSpeaking]="userIsSpeaking"
      [avatarIsSpeaking]="avatarIsSpeaking"
      [showUserInitials]="showUserInitials"
      [captionsOn]="captionsOn()"
      [captionText]="captionText()"
      [captionsMaxWidth]="cardWidthPx()"
    />
  }
  <app-results-pathway-roleplay
    [practiceCallUuid]="
      roleplayService.practiceCallUuid() ||
      callStore?.getPracticeCallUuid() ||
      ''
    "
    [callType]="roleplayService.callType() || callStore?.getCallType() || ''"
    [endedEarly]="endedEarly"
    (returnToPathway)="returnToPathway.emit()"
    (cardWidthChanged)="cardWidthPx.set($event)"
  />

</div>

@if (!footerService.isHidden() && (footerService.coachLine() || (roleplayService.isResolvingNextStep() && stepType() === PathwayStepType.CERTIFICATION_CALL)) && !roleplayService.isDebriefStarting() && !roleplayService.debriefInstanceUuid()) {
  <app-pathway-call-footer>
    <app-pathway-call-controls
      [isMicOn]="false"
      [isVideoOn]="false"
      [isCameraAvailable]="false"
      [showCameraButton]="false"
      [showMicrophoneButton]="false"
      [disableMicButton]="true"
      [disableVideoButton]="true"
      [disableConfirmActionButton]="footerService.isActionDisabled()"
      [confirmActionLabel]="ctaLabel()"
      (onConfirmActionClicked)="confirmAction.emit()"
    />
  </app-pathway-call-footer>
}
